export default __webpack_public_path__ + "static/media/pfp.575fe75a.mp4";